import { Button, Form, Input } from 'antd';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

import { PitstopSelect } from './PitstopSelect';

export const PitstopFormInlinePartial = ({ fields, onSubmit, submitText }) => {
  const [form] = Form.useForm();
  const [submitDisabled, setSubmitDisabled] = useState(true);

  // Watch for form field errors to enable/disable submit button
  const formValues = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmitDisabled(false))
      .catch(() => setSubmitDisabled(true));
  }, [formValues, form]);

  const handleSubmit = (values) => {
    onSubmit(values, form);
    // form.resetFields();
  };

  return (
    <Form
      form={form}
      layout="inline"
      onFinish={handleSubmit}
      style={{ gap: '16px', flexWrap: 'wrap' }}
    >
      {fields?.map((field) => {
        const rules = [];
        if (field.type === 'email') {
          rules.push({ type: 'email', message: 'Invalid email' });
        }
        if (field.required) {
          rules.push({ required: true, message: 'Required' });
          if (field.type === 'text') {
            rules.push({ whitespace: true, message: 'Required' });
          }
        }
        return (
          <Form.Item
            key={field.name}
            label={field.label}
            name={field.name}
            rules={rules}
          >
            {field?.type === 'select' ? (
              <PitstopSelect options={field.selectOptions} />
            ) : (
              <Input />
            )}
          </Form.Item>
        );
      })}
      <Button disabled={submitDisabled} type="primary" htmlType="submit">
        {submitText || 'Submit'}
      </Button>
    </Form>
  );
};

export const PitstopFormInline = PitstopFormInlinePartial;

PitstopFormInlinePartial.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      required: PropTypes.bool,
      selectOptions: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      ),
      // type: PropTypes.oneOf(['email', 'select', 'text']).isRequired
    })
  ).isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitText: PropTypes.string,
};
